<div class="tw-grid tw-grid-cols-[280px_1fr_auto] tw-w-full tw-h-screen tw-overflow-hidden">
  <sb-sidebar-menu [activeRouteGroup]="activeRouteGroup()" [activeAccountingGroup]="activeAccountingGroup()" />

  <div class="tw-w-full tw-overflow-hidden tw-pt-6">
    @if (activeRouteGroup() !== 'accounting' || activeAccountingGroup() === 'order-view') {
      <div class="tw-h-full tw-px-6 tw-overflow-auto tw-relative" cdkScrollable>
        <router-outlet></router-outlet>
      </div>
    }
    @if (activeRouteGroup() === 'accounting' && activeAccountingGroup() !== 'order-view') {
      <div class="tw-h-full tw-px-6 tw-grid tw-grid-rows-[auto{{ tabMenuItems?.length ? '_1fr' : '' }}]">
        @if (tabMenuItems?.length) {
          <p-tabs [value]="activeTabMenuItem?.routerLink">
            <p-tablist>
              @for (item of tabMenuItems; track item.routerLink) {
                <p-tab [value]="item.routerLink" [routerLink]="item.routerLink">
                  {{ item.label }}
                </p-tab>
              }
            </p-tablist>
          </p-tabs>
        }
        <div class="tw-min-h-0 tw-overflow-hidden">
          <router-outlet />
        </div>
      </div>
    }
  </div>

  <p-drawer
    [(visible)]="sidebarVisible"
    [position]="'right'"
    [style]="{ width: slideInWidth }"
    [baseZIndex]="1000"
    [showCloseIcon]="false"
    [modal]="slideInBackdrop"
    (onHide)="onCloseSlideIn()"
  >
    @if (slideInPortal) {
      <ng-template [cdkPortalOutlet]="slideInPortal" />
    }
  </p-drawer>
</div>
